var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 34,
    viewBox: "0 0 43 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 29C3 29.8284 3.67157 30.5 4.5 30.5H24.5663H38.5C39.3284 30.5 40 29.8284 40 29V18.8629V5C40 4.1716 39.3284 3.5 38.5 3.5H4.5C3.67157 3.5 3 4.1716 3 5V29ZM4.5 33.5C2.01472 33.5 0 31.4853 0 29V5C0 2.51472 2.01472 0.5 4.5 0.5H38.5C40.9853 0.5 43 2.51472 43 5V18.8629V29C43 31.4853 40.9853 33.5 38.5 33.5H24.5663H4.5ZM8.7222 15.5C7.8937 15.5 7.22217 16.1716 7.22217 17C7.22217 17.8284 7.8937 18.5 8.7222 18.5H33.7222C34.5506 18.5 35.2222 17.8284 35.2222 17C35.2222 16.1716 34.5506 15.5 33.7222 15.5H8.7222ZM7.22217 9.7778C7.22217 8.9493 7.8937 8.2778 8.7222 8.2778H33.7222C34.5506 8.2778 35.2222 8.9493 35.2222 9.7778C35.2222 10.6062 34.5506 11.2778 33.7222 11.2778H8.7222C7.8937 11.2778 7.22217 10.6062 7.22217 9.7778ZM8.7222 22.7222C7.8937 22.7222 7.22217 23.3938 7.22217 24.2222C7.22217 25.0507 7.8937 25.7222 8.7222 25.7222H14.8333C15.6617 25.7222 16.3333 25.0507 16.3333 24.2222C16.3333 23.3938 15.6617 22.7222 14.8333 22.7222H8.7222Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextArea);
export default __webpack_public_path__ + "static/media/text-area.6625867a500b714b37926dda8a653b31.svg";
export { ForwardRef as ReactComponent };